
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/used-cars-chiang-mai-brand/[brand]",
      function () {
        return require("private-next-pages/used-cars-chiang-mai-brand/[brand].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/used-cars-chiang-mai-brand/[brand]"])
      });
    }
  